import { useState } from "react";
import { connect } from "react-redux";
import { Stack, Typography } from "@mui/material";
import {
  FormBuilder,
  Form,
  ErrorMessage,
  getAuthClaims,
} from "@redriver/cinnamon-mui";
import { SubmitButton } from "components/buttons";
import { resendVerification } from "./actions";

const EmailVerificationResender = ({ userEmail, emailVerified }) => {
  const [requestSent, setRequestSent] = useState(false);
  const [requestEmail, setRequestEmail] = useState("");

  if (emailVerified) {
    return (
      <Typography variant="body2">
        Your email address has already been verified
      </Typography>
    );
  }

  if (requestSent) {
    return (
      <Typography variant="body2">
        A verification link has been sent
        {requestEmail ? ` to ${requestEmail}` : ""}
      </Typography>
    );
  }

  return (
    <FormBuilder
      initialData={{ email: userEmail }}
      submitAction={resendVerification}
      onSubmit={({ email }) => setRequestEmail(email)}
      onSubmitted={() => setRequestSent(true)}
      renderSubmitting={false}
      renderError={false}
      renderForm={(
        formProps,
        { submitting, slowSubmitting, error },
        events
      ) => (
        <Form {...formProps}>
          {!userEmail && (
            <Form.Email
              field="email"
              label="Email"
              placeholder="Enter email address"
              disabled={submitting && slowSubmitting}
              autoFocus
              required
              fluid
            />
          )}
          <Stack alignItems="flex-start" spacing={4}>
            <SubmitButton
              variant="contained"
              onClick={events.onSubmit}
              submitting={submitting}
              slowSubmitting={slowSubmitting}
              fullWidth
            >
              Request Verification Email
            </SubmitButton>
            <ErrorMessage error={error} fullWidth />
          </Stack>
        </Form>
      )}
    />
  );
};

const mapStateToProps = (state) => {
  const { userEmail, emailVerified } = getAuthClaims(state);
  return {
    userEmail,
    emailVerified,
  };
};

export default connect(mapStateToProps)(EmailVerificationResender);
